"use client";

import posthog from "posthog-js";

type AnalyticsValue = boolean | number | string | null | undefined;

export function trackEvent(
  eventName: string,
  properties?: Record<string, AnalyticsValue>,
): void {
  if (typeof window === "undefined" || !process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    return;
  }

  posthog.capture(eventName, properties);
}
